// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"TableRso_tableContainer__1eH94","scrollWrapper":"TableRso_scrollWrapper__3xtUb"};